export default __webpack_public_path__ + "static/media/Datchik-dvizheniya_about.88c57834.webp";